'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Tools = function Tools() {
  return React__default["default"].createElement("svg", {
    width: "435",
    height: "298",
    viewBox: "0 0 435 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("g", {
    opacity: "0.16",
    filter: "url(#filter0_f)"
  }, React__default["default"].createElement("path", {
    d: "M87.6013 252H24.1953C21.0089 252 18.1263 253.891 16.8572 256.814C14.5632 262.097 18.4356 268 24.1953 268H67.5789H87.6013C93.4132 268 97.2855 261.999 94.8904 256.703C93.5953 253.84 90.7438 252 87.6013 252Z",
    fill: "#00314A"
  })), React__default["default"].createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M84.209 40.7228V4.24102C84.209 1.03814 87.9003 -1.05256 90.6716 0.553242C101.072 6.57949 113.542 15.8434 113.542 54.9203C113.542 74.9114 99.2917 87.33 83.8759 93.9478V236.861C83.8759 252.015 71.5916 264.299 56.4382 264.299C41.2847 264.299 29.0004 252.015 29.0004 236.861L29.0004 93.9585C13.9525 87.2616 0 74.6959 0 54.9203C0 16.3211 12.559 6.81046 22.7135 0.775767C25.509 -0.885579 29.3335 1.24388 29.3335 4.4958V40.717C29.3335 42.1951 30.1586 43.5638 31.4631 44.2586L54.8936 56.7382C56.069 57.3642 57.4735 57.3642 58.6489 56.7382L82.0794 44.2586C83.3839 43.5638 84.209 42.2008 84.209 40.7228ZM56.4406 252.503C65.2571 252.503 72.4044 245.461 72.4044 236.775C72.4044 228.089 65.2571 221.047 56.4406 221.047C47.624 221.047 40.4768 228.089 40.4768 236.775C40.4768 245.461 47.624 252.503 56.4406 252.503Z"
  })), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M84.209 40.7228V4.24102C84.209 1.03814 87.9003 -1.05256 90.6716 0.553242C101.072 6.57949 113.542 15.8434 113.542 54.9203C113.542 74.9114 99.2917 87.33 83.8759 93.9478V236.861C83.8759 252.015 71.5916 264.299 56.4382 264.299C41.2847 264.299 29.0004 252.015 29.0004 236.861L29.0004 93.9585C13.9525 87.2616 0 74.6959 0 54.9203C0 16.3211 12.559 6.81046 22.7135 0.775767C25.509 -0.885579 29.3335 1.24388 29.3335 4.4958V40.717C29.3335 42.1951 30.1586 43.5638 31.4631 44.2586L54.8936 56.7382C56.069 57.3642 57.4735 57.3642 58.6489 56.7382L82.0794 44.2586C83.3839 43.5638 84.209 42.2008 84.209 40.7228ZM56.4406 252.503C65.2571 252.503 72.4044 245.461 72.4044 236.775C72.4044 228.089 65.2571 221.047 56.4406 221.047C47.624 221.047 40.4768 228.089 40.4768 236.775C40.4768 245.461 47.624 252.503 56.4406 252.503Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M90.6716 0.553242L91.6743 -1.17723V-1.17723L90.6716 0.553242ZM83.8759 93.9478L83.087 92.11L81.8759 92.6299V93.9478H83.8759ZM29.0004 93.9585H31.0004V92.6594L29.8136 92.1313L29.0004 93.9585ZM22.7135 0.775767L23.7352 2.49507L22.7135 0.775767ZM31.4631 44.2586L30.5229 46.0238L31.4631 44.2586ZM54.8936 56.7382L53.9534 58.5034L54.8936 56.7382ZM58.6489 56.7382L57.7087 54.9729H57.7087L58.6489 56.7382ZM82.0794 44.2586L83.0196 46.0238L82.0794 44.2586ZM82.209 4.24102V40.7228H86.209V4.24102H82.209ZM91.6743 -1.17723C87.5949 -3.54107 82.209 -0.531817 82.209 4.24102H86.209C86.209 2.6081 88.2058 1.43595 89.6689 2.28372L91.6743 -1.17723ZM115.542 54.9203C115.542 35.1935 112.399 22.7316 107.755 14.3717C103.08 5.95328 96.9966 1.90674 91.6743 -1.17723L89.6689 2.28372C94.7466 5.22599 100.099 8.82452 104.259 16.3139C108.451 23.8617 111.542 35.5702 111.542 54.9203H115.542ZM84.6649 95.7856C100.418 89.0229 115.542 76.0687 115.542 54.9203H111.542C111.542 73.7541 98.165 85.6372 83.087 92.11L84.6649 95.7856ZM85.8759 236.861V93.9478H81.8759V236.861H85.8759ZM56.4382 266.299C72.6962 266.299 85.8759 253.119 85.8759 236.861H81.8759C81.8759 250.91 70.4871 262.299 56.4382 262.299V266.299ZM27.0004 236.861C27.0004 253.119 40.1801 266.299 56.4382 266.299V262.299C42.3893 262.299 31.0004 250.91 31.0004 236.861H27.0004ZM27.0004 93.9585L27.0004 236.861H31.0004L31.0004 93.9585H27.0004ZM-2 54.9203C-2 75.8266 12.7911 88.9338 28.1872 95.7857L29.8136 92.1313C15.1139 85.5893 2 73.5653 2 54.9203H-2ZM21.6917 -0.943537C16.4914 2.14694 10.4598 6.25649 5.79942 14.667C1.16828 23.0247 -2 35.4248 -2 54.9203H2C2 35.8166 5.11121 24.1618 9.29819 16.6057C13.4559 9.10241 18.7811 5.43929 23.7352 2.49507L21.6917 -0.943537ZM31.3335 4.4958C31.3335 -0.343339 25.789 -3.37851 21.6917 -0.943537L23.7352 2.49507C25.229 1.60735 27.3335 2.83109 27.3335 4.4958H31.3335ZM31.3335 40.717V4.4958H27.3335V40.717H31.3335ZM32.4033 42.4934C31.7483 42.1445 31.3335 41.4529 31.3335 40.717H27.3335C27.3335 42.9372 28.5689 44.9831 30.5229 46.0238L32.4033 42.4934ZM55.8338 54.9729L32.4033 42.4934L30.5229 46.0238L53.9534 58.5034L55.8338 54.9729ZM57.7087 54.9729C57.121 55.286 56.4215 55.286 55.8338 54.9729L53.9534 58.5034C55.7165 59.4425 57.826 59.4425 59.5891 58.5034L57.7087 54.9729ZM81.1392 42.4934L57.7087 54.9729L59.5891 58.5034L83.0196 46.0238L81.1392 42.4934ZM82.209 40.7228C82.209 41.4555 81.7971 42.143 81.1392 42.4934L83.0196 46.0238C84.9707 44.9846 86.209 42.9462 86.209 40.7228H82.209ZM70.4044 236.775C70.4044 244.329 64.1807 250.503 56.4406 250.503V254.503C66.3335 254.503 74.4044 246.594 74.4044 236.775H70.4044ZM56.4406 223.047C64.1807 223.047 70.4044 229.221 70.4044 236.775H74.4044C74.4044 226.956 66.3335 219.047 56.4406 219.047V223.047ZM42.4768 236.775C42.4768 229.221 48.7004 223.047 56.4406 223.047V219.047C46.5476 219.047 38.4768 226.956 38.4768 236.775H42.4768ZM56.4406 250.503C48.7004 250.503 42.4768 244.329 42.4768 236.775H38.4768C38.4768 246.594 46.5476 254.503 56.4406 254.503V250.503Z",
    fill: "#0069C0",
    mask: "url(#path-2-inside-1)"
  }), React__default["default"].createElement("rect", {
    width: "34.994",
    height: "4.39255",
    rx: "2.19627",
    transform: "matrix(-0.881471 -0.472239 0.466712 -0.88441 57.0498 67.9929)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "34.994",
    height: "4.39255",
    rx: "2.19627",
    transform: "matrix(-0.881471 0.472239 -0.466712 -0.88441 86.3945 51.4685)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("rect", {
    x: "27.2051",
    y: "113.485",
    width: "59.1383",
    height: "86.0023",
    rx: "3",
    fill: "#3387CD",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "74.2412",
    y: "191.686",
    width: "35.2009",
    height: "6.55053",
    rx: "3.27526",
    transform: "rotate(-90 74.2412 191.686)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "32.2734",
    y: "191.686",
    width: "70.4019",
    height: "4.36702",
    rx: "2.18351",
    transform: "rotate(-90 32.2734 191.686)",
    fill: "white"
  }), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M53.8779 90.1113C53.883 91.2158 52.9917 92.1154 51.8872 92.1205C44.1618 92.1562 32.8714 89.5102 23.4638 83.6225C14.0107 77.7064 6.20774 68.3329 6.20774 54.9199C6.20774 53.8154 7.10318 52.9199 8.20774 52.9199C9.31231 52.9199 10.2077 53.8154 10.2077 54.9199C10.2077 66.5242 16.8826 74.785 25.5858 80.2318C34.3346 85.7071 44.8793 88.1528 51.8687 88.1205C52.9733 88.1154 53.8728 89.0067 53.8779 90.1113Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M78.6703 236.304C78.6703 248.454 68.283 258.523 56.2238 258.523C44.1647 258.523 34.3232 248.454 34.3232 236.304",
    stroke: "#C2DBF0",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("g", {
    opacity: "0.16",
    filter: "url(#filter1_f)"
  }, React__default["default"].createElement("path", {
    d: "M312.526 268L367.053 269L388.023 267.708C394.916 267.284 395.629 257.411 388.868 256L346.678 253.065C346.052 253.022 345.423 253.037 344.8 253.112L313.368 256.859C312.582 256.953 311.787 256.953 311 256.859L282.86 253.504C280.233 253.191 277.632 254.266 275.993 256.342C272.01 261.387 275.697 268.792 282.123 268.653L312.526 268Z",
    fill: "#00314A"
  })), React__default["default"].createElement("path", {
    d: "M337.418 5.52606C337.443 4.99221 337.883 4.57202 338.417 4.57202L364.274 4.57202C364.811 4.57202 365.252 4.99673 365.273 5.53371L374.965 258.31C374.986 258.877 374.533 259.349 373.965 259.349H326.788C326.218 259.349 325.763 258.872 325.79 258.303L337.418 5.52606Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "361.357",
    y: "116.759",
    width: "60.9766",
    height: "4.17815",
    rx: "2.08907",
    transform: "rotate(-92 361.357 116.759)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("path", {
    d: "M327.631 125.957C327.699 124.351 329.021 123.084 330.628 123.084H370.11C371.717 123.084 373.039 124.351 373.107 125.957L378.639 256.001C378.809 259.981 375.629 263.299 371.646 263.299H329.092C325.109 263.299 321.929 259.981 322.098 256.001L327.631 125.957Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    width: "33.6422",
    height: "6.30791",
    rx: "3.15396",
    transform: "matrix(-0.0348954 -0.999391 0.999391 -0.0349036 367.354 249.515)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    width: "66.1351",
    height: "4.20528",
    rx: "2.10264",
    transform: "matrix(0.0348954 -0.999391 0.999391 0.0349036 328.18 245.375)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("mask", {
    id: "path-17-inside-2",
    fill: "white"
  }, React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M277.344 5.54761C275.135 5.54761 273.344 7.33847 273.344 9.54761V41.6212C273.344 43.8304 275.135 45.6212 277.344 45.6212H295C295.998 45.6212 296.84 44.8862 296.98 43.9045C297.705 44.9432 298.911 45.6239 300.273 45.6305C307.47 45.6653 313.526 45.7891 319.662 45.9145C327.133 46.0672 334.722 46.2223 344.632 46.2223C368.669 46.2223 372.976 46.2223 375.558 44.1119C377.222 42.7515 378.169 40.514 383.223 36.8343C383.879 36.3564 384.69 36.0981 385.501 36.1298C395.791 36.5328 404.919 41.8341 413.605 46.8786C419.282 50.1763 424.771 53.3643 430.273 55.0025C433.318 55.9091 435.421 52.5118 433.891 49.7275C425.792 34.9858 409.164 6.14869 373.966 6.1487L343.937 6.1487L300.139 6.1487C298.872 6.1487 297.744 6.73684 297.024 7.65915L296.988 7.32725C296.875 6.31416 296.019 5.54761 295 5.54761H277.344Z"
  })), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M277.344 5.54761C275.135 5.54761 273.344 7.33847 273.344 9.54761V41.6212C273.344 43.8304 275.135 45.6212 277.344 45.6212H295C295.998 45.6212 296.84 44.8862 296.98 43.9045C297.705 44.9432 298.911 45.6239 300.273 45.6305C307.47 45.6653 313.526 45.7891 319.662 45.9145C327.133 46.0672 334.722 46.2223 344.632 46.2223C368.669 46.2223 372.976 46.2223 375.558 44.1119C377.222 42.7515 378.169 40.514 383.223 36.8343C383.879 36.3564 384.69 36.0981 385.501 36.1298C395.791 36.5328 404.919 41.8341 413.605 46.8786C419.282 50.1763 424.771 53.3643 430.273 55.0025C433.318 55.9091 435.421 52.5118 433.891 49.7275C425.792 34.9858 409.164 6.14869 373.966 6.1487L343.937 6.1487L300.139 6.1487C298.872 6.1487 297.744 6.73684 297.024 7.65915L296.988 7.32725C296.875 6.31416 296.019 5.54761 295 5.54761H277.344Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M296.98 43.9045L298.619 42.759L295.715 38.6029L295 43.6221L296.98 43.9045ZM300.273 45.6305L300.263 47.6305H300.263L300.273 45.6305ZM319.662 45.9145L319.621 47.9141L319.662 45.9145ZM344.632 46.2223V44.2223V46.2223ZM375.558 44.1119L376.824 45.6604V45.6604L375.558 44.1119ZM383.223 36.8343L384.4 38.4511V38.4511L383.223 36.8343ZM385.501 36.1298L385.579 34.1313L385.501 36.1298ZM413.605 46.8786L412.6 48.6081L413.605 46.8786ZM430.273 55.0025L430.844 53.0857L430.273 55.0025ZM433.891 49.7275L435.644 48.7645V48.7645L433.891 49.7275ZM373.966 6.1487V8.1487V6.1487ZM343.937 6.1487V8.1487V8.1487V6.1487ZM300.139 6.1487V4.1487V6.1487ZM297.024 7.65915L295.037 7.87951L295.578 12.7644L298.601 8.88939L297.024 7.65915ZM296.988 7.32725L295 7.54761V7.54761L296.988 7.32725ZM275.344 9.54761C275.344 8.44304 276.239 7.54761 277.344 7.54761V3.54761C274.03 3.54761 271.344 6.2339 271.344 9.54761H275.344ZM275.344 41.6212V9.54761H271.344V41.6212H275.344ZM277.344 43.6212C276.239 43.6212 275.344 42.7258 275.344 41.6212H271.344C271.344 44.9349 274.03 47.6212 277.344 47.6212V43.6212ZM295 43.6212H277.344V47.6212H295V43.6212ZM295 43.6221L295 43.6212V47.6212C296.996 47.6212 298.679 46.1512 298.96 44.1868L295 43.6221ZM300.282 43.6305C299.595 43.6272 298.987 43.2858 298.619 42.759L295.34 45.0499C296.423 46.6007 298.226 47.6206 300.263 47.6305L300.282 43.6305ZM319.703 43.9149C313.567 43.7895 307.497 43.6654 300.282 43.6305L300.263 47.6305C307.443 47.6652 313.485 47.7887 319.621 47.9141L319.703 43.9149ZM344.632 44.2223C334.744 44.2223 327.173 44.0676 319.703 43.9149L319.621 47.9141C327.093 48.0668 334.699 48.2223 344.632 48.2223V44.2223ZM374.292 42.5635C373.536 43.1814 372.397 43.7 368.021 43.9621C363.693 44.2213 356.688 44.2223 344.632 44.2223V48.2223C356.613 48.2223 363.78 48.2233 368.26 47.9549C372.693 47.6894 374.998 47.1528 376.824 45.6604L374.292 42.5635ZM382.046 35.2175C379.399 37.1448 377.797 38.7182 376.637 40.0007C376.093 40.6014 375.59 41.2042 375.243 41.6003C374.861 42.0362 374.577 42.3306 374.292 42.5635L376.824 45.6604C377.371 45.213 377.829 44.7175 378.251 44.2364C378.708 43.7153 379.069 43.2737 379.602 42.685C380.594 41.5888 381.993 40.2036 384.4 38.4511L382.046 35.2175ZM385.579 34.1313C384.299 34.0812 383.049 34.4868 382.046 35.2175L384.4 38.4511C384.709 38.2261 385.081 38.1149 385.423 38.1283L385.579 34.1313ZM414.609 45.1492C406.01 40.1548 396.451 34.557 385.579 34.1313L385.423 38.1283C395.132 38.5085 403.828 43.5133 412.6 48.6081L414.609 45.1492ZM430.844 53.0857C425.614 51.5285 420.34 48.4775 414.609 45.1492L412.6 48.6081C418.225 51.8752 423.929 55.2001 429.702 56.9193L430.844 53.0857ZM432.138 50.6905C432.542 51.4265 432.438 52.1775 432.128 52.6478C431.856 53.0598 431.45 53.2662 430.844 53.0857L429.702 56.9193C432.14 57.6454 434.308 56.6065 435.467 54.8504C436.587 53.1526 436.769 50.8128 435.644 48.7645L432.138 50.6905ZM373.966 8.1487C407.878 8.14869 423.997 35.8726 432.138 50.6905L435.644 48.7645C427.587 34.099 410.45 4.14869 373.966 4.1487V8.1487ZM343.937 8.1487L373.966 8.1487V4.1487L343.937 4.1487V8.1487ZM300.139 8.1487L343.937 8.1487V4.1487L300.139 4.1487V8.1487ZM298.601 8.88939C298.951 8.44071 299.504 8.1487 300.139 8.1487V4.1487C298.241 4.1487 296.537 5.03297 295.447 6.42891L298.601 8.88939ZM295 7.54761L295.037 7.87951L299.012 7.43879L298.975 7.10689L295 7.54761ZM295 7.54761L295 7.54761L298.975 7.10689C298.751 5.08072 297.038 3.54761 295 3.54761V7.54761ZM277.344 7.54761H295V3.54761H277.344V7.54761Z",
    fill: "#0069C0",
    mask: "url(#path-17-inside-2)"
  }), React__default["default"].createElement("rect", {
    width: "63.0717",
    height: "4.20528",
    rx: "2.10264",
    transform: "matrix(-1 0 -0.00625875 -0.99998 372.116 15.4233)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "8.41107",
    height: "4.20553",
    rx: "2.10277",
    transform: "matrix(-1 0 -0.00625875 -0.99998 292.293 14.0859)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "10.5138",
    height: "4.20553",
    rx: "2.10277",
    transform: "matrix(-1 0 -0.00625948 -0.99998 293.226 41.1006)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("rect", {
    width: "31.5359",
    height: "6.30791",
    rx: "3.15396",
    transform: "matrix(1 0 -0.00625875 0.99998 334.595 254.423)",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M378.002 27.4643C377.898 26.3647 378.704 25.3884 379.804 25.2837C390.788 24.2374 401.978 28.7972 410.243 33.4213C414.41 35.7527 417.911 38.1444 420.37 39.9536C421.601 40.859 422.575 41.6207 423.244 42.1591C423.579 42.4284 423.837 42.642 424.014 42.7899C424.103 42.8639 424.171 42.9215 424.218 42.9615L424.273 43.008L424.288 43.0211L424.294 43.0264C424.295 43.0269 424.295 43.0273 422.987 44.5403L424.295 43.0273C425.131 43.7496 425.222 45.0126 424.5 45.8482C423.778 46.6837 422.515 46.7756 421.679 46.0537M421.679 46.0537L421.669 46.0446L421.627 46.0088C421.588 45.976 421.529 45.9258 421.45 45.8594C421.29 45.7265 421.051 45.5286 420.736 45.2756C420.107 44.7694 419.18 44.0434 418 43.1759C415.639 41.4391 412.279 39.144 408.29 36.9121C400.242 32.4096 389.936 28.3366 380.183 29.2657C379.083 29.3704 378.107 28.5639 378.002 27.4643",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    width: "63.0717",
    height: "4.20528",
    rx: "2.10264",
    transform: "matrix(1 0 -0.00625875 0.99998 306.944 37.0232)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "277.294",
    y: "39.126",
    width: "25.2317",
    height: "4.20528",
    rx: "2.10264",
    transform: "rotate(-90 277.294 39.126)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("g", {
    opacity: "0.16",
    filter: "url(#filter2_f)"
  }, React__default["default"].createElement("path", {
    d: "M225.601 270H162.195C159.009 270 156.126 271.891 154.857 274.814C152.563 280.097 156.436 286 162.195 286H205.579H225.601C231.413 286 235.286 279.999 232.89 274.703C231.595 271.84 228.744 270 225.601 270Z",
    fill: "#00314A"
  })), React__default["default"].createElement("path", {
    d: "M184.281 21.2797C184.41 20.8592 184.798 20.572 185.238 20.572H203.168C203.608 20.572 203.996 20.8592 204.125 21.2797L205.081 20.9873L204.125 21.2797L211.816 46.4373C211.89 46.6817 211.869 46.9456 211.755 47.1745L203.966 62.8543C203.756 63.2766 203.648 63.7424 203.652 64.214L205.404 274.341C205.409 274.896 204.96 275.349 204.404 275.349H182.497C181.939 275.349 181.488 274.892 181.497 274.334L184.75 64.2287C184.757 63.7499 184.65 63.2763 184.437 62.8475L176.651 47.1745C176.537 46.9456 176.516 46.6817 176.59 46.4373L184.281 21.2797Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M168.822 142.002C168.867 140.377 170.196 139.084 171.821 139.084H215.067C216.691 139.084 218.021 140.377 218.065 142.002L221.654 272.106C221.763 276.046 218.599 279.299 214.657 279.299H172.231C168.289 279.299 165.125 276.046 165.233 272.106L168.822 142.002Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M168.183 128.787C168.499 127.429 169.71 126.468 171.104 126.468H215.783C217.178 126.468 218.388 127.429 218.705 128.787L219.617 132.7C220.641 137.09 217.309 141.289 212.8 141.289H174.087C169.579 141.289 166.246 137.09 167.27 132.7L168.183 128.787Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    width: "33.0673",
    height: "6.11387",
    rx: "3.05694",
    transform: "matrix(-0.0346746 -0.999399 0.999383 -0.0351259 210.322 265.515)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    width: "66.1346",
    height: "4.07592",
    rx: "2.03796",
    transform: "matrix(0.0346746 -0.999399 0.999383 0.0351259 171.395 261.375)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("rect", {
    width: "12.5352",
    height: "4.20554",
    rx: "2.10277",
    transform: "matrix(-1 0 -0.0062191 -0.999981 200.492 27.9827)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "16.7983",
    height: "4.18454",
    rx: "2.09227",
    transform: "matrix(-0.467105 -0.884202 0.878701 -0.477373 187.646 61.5754)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("rect", {
    width: "16.7983",
    height: "4.18454",
    rx: "2.09227",
    transform: "matrix(-0.323092 -0.946368 0.94254 -0.334093 201.304 40.7976)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "31.3994",
    height: "5.92562",
    rx: "2.96281",
    transform: "matrix(1 0 -0.0062191 0.999981 177.769 270.424)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    width: "33.4252",
    height: "4.20528",
    rx: "2.10264",
    transform: "matrix(1 0 -0.0062191 0.999981 177.495 135.027)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "196.292",
    y: "124.705",
    width: "60.9766",
    height: "4.17815",
    rx: "2.08907",
    transform: "rotate(-90 196.292 124.705)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    id: "filter0_f",
    x: "4.18652",
    y: "240",
    width: "103.424",
    height: "40",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, React__default["default"].createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "filter1_f",
    x: "262.343",
    y: "241.041",
    width: "143.24",
    height: "39.9587",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, React__default["default"].createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "filter2_f",
    x: "142.187",
    y: "258",
    width: "103.424",
    height: "40",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, React__default["default"].createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  }))));
};

module.exports = Tools;
